import type { EIN, EINDash, UUID } from '@endaoment-frontend/types';

import { makeRoute } from './makeRoute';
import { formatEinOrUuid } from './utils';

export const home = makeRoute(() => `/`, 'miniApp');
export const uip = makeRoute(() => `/universal`, 'miniApp');
export const org = makeRoute(
  (args: { einOrId: EIN | EINDash | UUID }) => `/orgs/${formatEinOrUuid(args.einOrId)}`,
  'miniApp',
);
